import React, { Component } from 'react';
// import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import GoogleMap from './components/GoogleMap'

import axios from 'axios';
import PropTypes from 'prop-types';
import './EquipmentDetail.css';
import { FormattedDate } from 'react-intl';
import 'moment/locale/ja'
import moment from 'moment';

class EquipmentDetail extends Component {
  componentWillMount() {
    this.updateResource();
  }

  updateResource() {
    const { groupId, equipmentId } = this.props.match.params;
    axios.get(`https://kiz.ai/api/groups/${groupId}/equipments/${equipmentId}`)
      .then(
        response => response.data,
        error => console.error(groupId, equipmentId, error)
      )
      .then(
        data => this.setState({equipment: data})
      )
  }

  render() {
    return (
      <div className="EquipmentDetail">
        { this.state ? this.renderEquipment(this.state.equipment) : null}
      </div>
    );
  }

  renderEquipment(equipment) {
    const style =
      equipment.images && equipment.images.length > 0 ?
      { backgroundImage: `url(${equipment.images[0].url})` } : {} ;
    return [
      (
        <div className="cover">
          <div className="image" style={ style } />
          <div className="shadow" />
          <p className="maker">{ equipment.maker }</p>
          <p className="name">{ equipment.name }</p>
        </div>
      ),(
        <div className="detail">
          <h2>
            最後のスキャン
            <span className="scanTimestamp">{ moment(equipment.lastScan.timestamp).fromNow() }</span>
          </h2>
          <p>
            { equipment.lastScan.address.name }
          </p>
            {/*<FormattedDate
                value={ equipment.lastScan.timestamp }
                day="numeric"
                month="long"
                year="numeric" />*/}
          {/*<p>{ equipment.lastScan.timestamp }</p>*/}
          <GoogleMap
            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&amp;libraries=geometry,drawing,places&amp;key=AIzaSyCodCGz7_MwWzl1AA6nVhdL4oyXdQ647lk"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `300px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            lat={ equipment.lastScan.address.location._latitude }
            lng={ equipment.lastScan.address.location._longitude }>
          </GoogleMap>
        </div>
      )
    ];
  }
}

EquipmentDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      groupId: PropTypes.string,
      equipmentId: PropTypes.string,
    }),
  }),
};

export default EquipmentDetail;



// WEBPACK FOOTER //
// ./src/EquipmentDetail.js